/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Method_Content_Step_02_Detail_Tournament_2_HeadingInputs */

const en_method_content_step_02_detail_tournament_2_heading = /** @type {(inputs: Method_Content_Step_02_Detail_Tournament_2_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Why adaptation speed matters`)
};

const es_method_content_step_02_detail_tournament_2_heading = /** @type {(inputs: Method_Content_Step_02_Detail_Tournament_2_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Por qué importa la velocidad de adaptación`)
};

const de_method_content_step_02_detail_tournament_2_heading = /** @type {(inputs: Method_Content_Step_02_Detail_Tournament_2_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Warum Anpassungsgeschwindigkeit wichtig ist`)
};

const zh_method_content_step_02_detail_tournament_2_heading = /** @type {(inputs: Method_Content_Step_02_Detail_Tournament_2_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`为什么适应速度很重要`)
};

const ar_method_content_step_02_detail_tournament_2_heading = /** @type {(inputs: Method_Content_Step_02_Detail_Tournament_2_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`لماذا تهم سرعة التكيف`)
};

const fr_method_content_step_02_detail_tournament_2_heading = /** @type {(inputs: Method_Content_Step_02_Detail_Tournament_2_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pourquoi la vitesse d'adaptation est importante`)
};

const vi_method_content_step_02_detail_tournament_2_heading = /** @type {(inputs: Method_Content_Step_02_Detail_Tournament_2_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vì sao tốc độ thích nghi quan trọng`)
};

const sw_method_content_step_02_detail_tournament_2_heading = /** @type {(inputs: Method_Content_Step_02_Detail_Tournament_2_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kwa nini kasi ya kuzoea ni muhimu`)
};

const th_method_content_step_02_detail_tournament_2_heading = /** @type {(inputs: Method_Content_Step_02_Detail_Tournament_2_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ทำไมความเร็วในการปรับตัวจึงสำคัญ`)
};

const bs_method_content_step_02_detail_tournament_2_heading = /** @type {(inputs: Method_Content_Step_02_Detail_Tournament_2_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zašto je brzina adaptacije bitna`)
};

const ja_method_content_step_02_detail_tournament_2_heading = /** @type {(inputs: Method_Content_Step_02_Detail_Tournament_2_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`適応の速さが重要な理由`)
};

const ko_method_content_step_02_detail_tournament_2_heading = /** @type {(inputs: Method_Content_Step_02_Detail_Tournament_2_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`적응 속도가 중요한 이유`)
};

const pt_method_content_step_02_detail_tournament_2_heading = /** @type {(inputs: Method_Content_Step_02_Detail_Tournament_2_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Por que a velocidade de adaptação importa`)
};

const it_method_content_step_02_detail_tournament_2_heading = /** @type {(inputs: Method_Content_Step_02_Detail_Tournament_2_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Perché conta la velocità di adattamento`)
};

const sv_method_content_step_02_detail_tournament_2_heading = /** @type {(inputs: Method_Content_Step_02_Detail_Tournament_2_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Varför anpassningshastigheten spelar roll`)
};

const nl_method_content_step_02_detail_tournament_2_heading = /** @type {(inputs: Method_Content_Step_02_Detail_Tournament_2_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Waarom aanpassingssnelheid telt`)
};

const da_method_content_step_02_detail_tournament_2_heading = /** @type {(inputs: Method_Content_Step_02_Detail_Tournament_2_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hvorfor tilpasningshastigheden betyder noget`)
};

const nb_method_content_step_02_detail_tournament_2_heading = /** @type {(inputs: Method_Content_Step_02_Detail_Tournament_2_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hvorfor tilpasningstempoet betyr noe`)
};

const fi_method_content_step_02_detail_tournament_2_heading = /** @type {(inputs: Method_Content_Step_02_Detail_Tournament_2_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Miksi sopeutumisen nopeudella on väliä`)
};

const pl_method_content_step_02_detail_tournament_2_heading = /** @type {(inputs: Method_Content_Step_02_Detail_Tournament_2_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dlaczego liczy się tempo adaptacji`)
};

const ru_method_content_step_02_detail_tournament_2_heading = /** @type {(inputs: Method_Content_Step_02_Detail_Tournament_2_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Почему важна скорость адаптации`)
};

const tr_method_content_step_02_detail_tournament_2_heading = /** @type {(inputs: Method_Content_Step_02_Detail_Tournament_2_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Uyum hızı neden önemlidir`)
};

const hi_method_content_step_02_detail_tournament_2_heading = /** @type {(inputs: Method_Content_Step_02_Detail_Tournament_2_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ढलने की रफ़्तार क्यों मायने रखती है`)
};

const id_method_content_step_02_detail_tournament_2_heading = /** @type {(inputs: Method_Content_Step_02_Detail_Tournament_2_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mengapa kecepatan adaptasi penting`)
};

const ms_method_content_step_02_detail_tournament_2_heading = /** @type {(inputs: Method_Content_Step_02_Detail_Tournament_2_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mengapa kelajuan penyesuaian penting`)
};

const cs_method_content_step_02_detail_tournament_2_heading = /** @type {(inputs: Method_Content_Step_02_Detail_Tournament_2_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Proč záleží na rychlosti adaptace`)
};

const el_method_content_step_02_detail_tournament_2_heading = /** @type {(inputs: Method_Content_Step_02_Detail_Tournament_2_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Γιατί μετρά η ταχύτητα προσαρμογής`)
};

const he_method_content_step_02_detail_tournament_2_heading = /** @type {(inputs: Method_Content_Step_02_Detail_Tournament_2_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`למה מהירות ההסתגלות חשובה`)
};

const af_method_content_step_02_detail_tournament_2_heading = /** @type {(inputs: Method_Content_Step_02_Detail_Tournament_2_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Waarom aanpassingspoed belangrik is`)
};

const hu_method_content_step_02_detail_tournament_2_heading = /** @type {(inputs: Method_Content_Step_02_Detail_Tournament_2_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Miért számít az alkalmazkodás sebessége`)
};

/**
* | output |
* | --- |
* | "Why adaptation speed matters" |
*
* @param {Method_Content_Step_02_Detail_Tournament_2_HeadingInputs} inputs
* @param {{ locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }} options
* @returns {LocalizedString}
*/
export const method_content_step_02_detail_tournament_2_heading = /** @type {((inputs?: Method_Content_Step_02_Detail_Tournament_2_HeadingInputs, options?: { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Method_Content_Step_02_Detail_Tournament_2_HeadingInputs, { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_method_content_step_02_detail_tournament_2_heading(inputs)
	if (locale === "de") return de_method_content_step_02_detail_tournament_2_heading(inputs)
	if (locale === "zh") return zh_method_content_step_02_detail_tournament_2_heading(inputs)
	if (locale === "ar") return ar_method_content_step_02_detail_tournament_2_heading(inputs)
	if (locale === "fr") return fr_method_content_step_02_detail_tournament_2_heading(inputs)
	if (locale === "vi") return vi_method_content_step_02_detail_tournament_2_heading(inputs)
	if (locale === "sw") return sw_method_content_step_02_detail_tournament_2_heading(inputs)
	if (locale === "th") return th_method_content_step_02_detail_tournament_2_heading(inputs)
	if (locale === "bs") return bs_method_content_step_02_detail_tournament_2_heading(inputs)
	if (locale === "ja") return ja_method_content_step_02_detail_tournament_2_heading(inputs)
	if (locale === "ko") return ko_method_content_step_02_detail_tournament_2_heading(inputs)
	if (locale === "pt") return pt_method_content_step_02_detail_tournament_2_heading(inputs)
	if (locale === "it") return it_method_content_step_02_detail_tournament_2_heading(inputs)
	if (locale === "sv") return sv_method_content_step_02_detail_tournament_2_heading(inputs)
	if (locale === "nl") return nl_method_content_step_02_detail_tournament_2_heading(inputs)
	if (locale === "da") return da_method_content_step_02_detail_tournament_2_heading(inputs)
	if (locale === "nb") return nb_method_content_step_02_detail_tournament_2_heading(inputs)
	if (locale === "fi") return fi_method_content_step_02_detail_tournament_2_heading(inputs)
	if (locale === "pl") return pl_method_content_step_02_detail_tournament_2_heading(inputs)
	if (locale === "ru") return ru_method_content_step_02_detail_tournament_2_heading(inputs)
	if (locale === "tr") return tr_method_content_step_02_detail_tournament_2_heading(inputs)
	if (locale === "hi") return hi_method_content_step_02_detail_tournament_2_heading(inputs)
	if (locale === "id") return id_method_content_step_02_detail_tournament_2_heading(inputs)
	if (locale === "ms") return ms_method_content_step_02_detail_tournament_2_heading(inputs)
	if (locale === "cs") return cs_method_content_step_02_detail_tournament_2_heading(inputs)
	if (locale === "el") return el_method_content_step_02_detail_tournament_2_heading(inputs)
	if (locale === "he") return he_method_content_step_02_detail_tournament_2_heading(inputs)
	if (locale === "af") return af_method_content_step_02_detail_tournament_2_heading(inputs)
	if (locale === "hu") return hu_method_content_step_02_detail_tournament_2_heading(inputs)
	return en_method_content_step_02_detail_tournament_2_heading(inputs)
});